module.exports = exports = require('./svm');
exports.kernel = require('./kernel').kernel;



/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/